const COUNTRY_CODE_DIGITS = '268';

export const getFullMsisdn = (msisdn: string): string => {
  const digits = msisdn.replace(/\D/g, '');

  if (digits.startsWith(COUNTRY_CODE_DIGITS)) {
    return digits;
  }

  return `${COUNTRY_CODE_DIGITS}${digits}`;
};
